import { ValueObject } from '@nx-smartmonkey/shared/domain';
import { ProjectCustomersAppField } from './ProjectCustomersAppFields';
import { ProjectCustomersEntityField } from './ProjectCustomersEntityField';
import {
  ProjectCustomersStopCanceledType,
  ProjectCustomersStopCompletedType,
  ProjectCustomersStopFieldType,
} from './ProjectCustomersFields';
import { ProjectCustomersStyle } from './style/ProjectCustomersStyle';

interface ProjectCustomersProps {
  fields: Array<ProjectCustomersAppField>;
  stop_fields: Array<ProjectCustomersEntityField<ProjectCustomersStopFieldType>>;
  stop_completed_fields: Array<ProjectCustomersEntityField<ProjectCustomersStopCompletedType>>;
  stop_canceled_fields: Array<ProjectCustomersEntityField<ProjectCustomersStopCanceledType>>;
  style: ProjectCustomersStyle;
}

export class ProjectCustomers extends ValueObject<ProjectCustomersProps> {
  get fields(): ProjectCustomersAppField[] {
    return this.props.fields;
  }

  get stop_fields(): Array<ProjectCustomersEntityField<ProjectCustomersStopFieldType>> {
    return this.props.stop_fields;
  }

  get stop_completed_fields(): Array<ProjectCustomersEntityField<ProjectCustomersStopCompletedType>> {
    return this.props.stop_completed_fields;
  }

  get stop_canceled_fields(): Array<ProjectCustomersEntityField<ProjectCustomersStopCanceledType>> {
    return this.props.stop_canceled_fields;
  }

  get style(): ProjectCustomersStyle {
    return this.props.style;
  }

  set style(style: ProjectCustomersStyle) {
    this.props.style = style;
  }

  private constructor(props: ProjectCustomersProps) {
    super(props);
  }

  static create(props: ProjectCustomersProps): ProjectCustomers {
    return new ProjectCustomers(props);
  }

  removeStopCustomField(customFieldId: string): void {
    this.props.stop_fields = this.props.stop_fields.filter((field) => field.id !== customFieldId);
  }
}
